import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Page } from "../../activities/AppPage";
import { API } from "../../API";
import useCaregiver from "../../hooks/useCaregiver";
import { isLoading } from "../../Loading";
import { STRINGS } from "../../strings";
import { AppState } from "../../system/AppState";
import { translate } from "../../translate";
import ErrorScaffold from "../ErrorScaffold";
import LoadingScaffold from "../LoadingScaffold";
import RaffleScreen from "./RaffleScreen";

interface Props {
  api: API;
  appState: AppState;
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
}

export default function RaffleActivity(props: Props) {
  const query = useQuery({
    queryKey: ["raffle"],
    queryFn: () => props.api.getRaffle(),
  });

  const caregiver = useCaregiver(props.appState);

  if (isLoading(caregiver) || query.status === "loading") {
    return (
      <LoadingScaffold
        title={translate(STRINGS.MEDFLYT_RAFFLE)}
        onClickGoBack={props.onClickGoBack}
      />
    );
  }

  switch (query.status) {
    case "error":
      return (
        <ErrorScaffold
          title={translate(STRINGS.MEDFLYT_RAFFLE)}
          onClickGoBack={props.onClickGoBack}
          message={translate(STRINGS.SOMETHING_WENT_WRONG)}
        />
      );

    case "success":
      return (
        <RaffleScreen
          {...query.data}
          onTimeToChooseWinner={query.refetch}
          onClickGoBack={props.onClickGoBack}
          onRequestNavigate={props.onRequestNavigate}
          avatar={caregiver.photoUrl}
        />
      );
  }
}
